import { Dayjs } from 'dayjs'

export const getTimezoneAbbreviation = () => {
  const dateString = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' })
  const abbreviation = dateString.split(' ')[2]
  return abbreviation || Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const formatTo12Hour = (time: Dayjs | undefined) => {
  if (!time) return undefined
  const hour = time.hour() % 12 === 0 ? 12 : time.hour() % 12 // Convert 24-hour to 12-hour format
  const minute = time.minute()
  return `${hour}:${minute.toString().padStart(2, '0')}`
}
